// Cookies lišta - jednoduchá implementace
class CookiesBar {
  constructor() {
    this.cookiesBar = document.getElementById('cookies-bar');
    this.acceptBtn = document.getElementById('cookies-accept');
    this.declineBtn = document.getElementById('cookies-decline');
    this.cookieName = 'cookies_consent';
    this.cookieExpiry = 365; // dny
    
    this.init();
  }
  
  init() {
    if (this.hasConsent()) {
      return;
    }
    
    setTimeout(() => {
      this.showBar();
    }, 1000);
    
    this.acceptBtn?.addEventListener('click', () => this.acceptCookies());
    this.declineBtn?.addEventListener('click', () => this.declineCookies());
  }
  
  showBar() {
    this.cookiesBar?.classList.add('show');
  }
  
  hideBar() {
    this.cookiesBar?.classList.remove('show');
  }
  
  acceptCookies() {
    this.setCookie(this.cookieName, 'accepted', this.cookieExpiry);
    this.hideBar();
  }
  
  declineCookies() {
    this.setCookie(this.cookieName, 'declined', this.cookieExpiry);
    this.hideBar();
  }
  
  hasConsent() {
    return this.getCookie(this.cookieName) !== null;
  }
  
  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }
  
  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cookiesBarInstance = new CookiesBar();
});

document.addEventListener('turbo:load', () => {
  if (!window.cookiesBarInstance) {
    window.cookiesBarInstance = new CookiesBar();
  }
});
